// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../src/css/list.scss
// module id = 28
// module chunks = 0